import { render, staticRenderFns } from "./ThePopup.vue?vue&type=template&id=18819689&lang=pug"
import script from "./ThePopup.vue?vue&type=script&lang=js"
export * from "./ThePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports